const FETCH_LIST = 'keys/FETCH_KEYS_LIST';
const FETCH_LIST_ERROR = 'keys/FETCH_KEYS_LIST_ERROR';
const FETCH_LIST_INIT = 'keys/FETCH_KEYS_LIST_INIT';

export default {
  FETCH_LIST,
  FETCH_LIST_ERROR,
  FETCH_LIST_INIT,
};